import { t } from "@/i18n-js/instance";
import type { Step } from "@/react/components/CommunityOnboarding/NewChecklistComponents/types";
import type { ChecklistData } from "@/react/types";
import type { SectionKey, StepKey } from "@/react/types/Checklist";
import { localeRoot, sections } from "./ChecklistConstants";

export const createStep = (
  checklistData: ChecklistData,
  stepKey: StepKey,
  sectionKey: SectionKey,
  customAction?: () => void | Promise<void>,
  customContent?: React.ComponentType,
): Step => ({
  title: t(`${localeRoot}.sections.${sectionKey}.steps.${stepKey}.title`),
  cta: t(`${localeRoot}.sections.${sectionKey}.steps.${stepKey}.cta`),
  complete: checklistData[stepKey],
  focus: false,
  key: stepKey,
  description: t(
    `${localeRoot}.sections.${sectionKey}.steps.${stepKey}.description`,
  ),
  customAction,
  customContent,
});

export const getInitialExpandedSections = (
  checklist: ChecklistData | undefined,
  initialFocusedStepKey: StepKey | null | undefined,
): Set<string> => {
  if (!checklist || !initialFocusedStepKey) return new Set<string>();
  const sectionWithFocusedStep = sections.find(section =>
    section.steps.includes(initialFocusedStepKey),
  );
  return sectionWithFocusedStep
    ? new Set([sectionWithFocusedStep.title])
    : new Set<string>();
};
